module.exports = __webpack_public_path__ + "static/media/upload.b94ba1c5.svg";